import axios from "axios";
import { baseURL } from ".";
import swal from 'sweetalert2';
// Create a custom Axios instance
const apiClient = axios.create({
  baseURL: baseURL,
  timeout: 30000, // Optional: set a timeout for requests
});

// Add Response Interceptor
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const responseData = error.response?.data || {};
      const message =
        responseData.message ||
        "Session expired. Please login again.";

      swal.fire({
        title: responseData.loggedInElsewhere ? "Logged Out" : "Session Expired",
        text: message,
        icon: "warning",
        showCancelButton: false,
        confirmButtonColor: "#28bb4b",
        cancelButtonColor: "#f34e4e",
        confirmButtonText: "Login again",
      }).then((result) => {
        if (result.isConfirmed) {
          localStorage.removeItem("asg_insurance_admin");
          window.location.href = "/login";
        }
      });
    }
    return Promise.reject(error);
  }
);

export default apiClient;
